<template>
  <Card class="map-card">
    <div class="text-xs-center pt-3 pb-3">POWER FLOW</div>
    <v-divider class="custom-divider" />
    <div class="flow-diagram pa-4">
      <FlowDiagram />
    </div>
  </Card>
</template>

<script>
import FlowDiagram from "./FlowDiagram.vue";

export default {
  name: "PowerFlowCard",
  components: {
    FlowDiagram,
  },
};
</script>

<style scoped>
.map-card {
  height: 400px;
  border: 1px solid #334079 !important;
  border-radius: 8px;
  box-shadow: 0px 5px 5px 0px #334079;
}

.flow-diagram {
  width: 100%;
  height: calc(100% - 60px);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.custom-divider {
  border-color: #334079 !important;
}
</style>
